<template>
  <div class="asc-grid-folder-cell">
    <span class="asc-value">
      <i class="mdi mdi-folder"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AscGridFolderCell',

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style lang="scss">
.asc-grid-folder-cell {
  display: flex;
  justify-content: center;
  width: 100%;
  color: $accent-600;
  font-size: 16px;
}
</style>
